import { useEffect, useRef, useState } from 'react';
import { checkHasMattressBuilderPermission } from './commonHelper';
import { LogConsole } from '../../../../helpers/logEvents';
import { useUserContext } from '../../../../contexts/UserContext';

// Cache by organization
const permissionCache = {};
// Track in-flight requests by org
const inflightRequests = {};

export const useMattressBuilderPermission = () => {
  const { currentUser } = useUserContext();
  const orgId = currentUser?.organization;
  const [loading, setLoading] = useState(false);
  const [permission, setPermission] = useState(
    orgId && permissionCache[orgId] ? permissionCache[orgId].permission : false
  );
  const [addPermission, setAddPermission] = useState(
    orgId && permissionCache[orgId] ? permissionCache[orgId].addPermission : false
  );

  const isMountedRef = useRef(true);
  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  useEffect(() => {
    if (!orgId) return;
    getPermission();
  }, [orgId]);

  const getPermission = async () => {
    // If we already have cache → just set it and skip
    if (permissionCache[orgId]) {
      if (!isMountedRef.current) return;
      setPermission(permissionCache[orgId].permission);
      setAddPermission(permissionCache[orgId].addPermission);
      setLoading(false);
      return;
    }
    setLoading(true);
    // If another request is already in progress for this org → wait for it
    if (inflightRequests[orgId]) {
      const result = await inflightRequests[orgId];
      if (!isMountedRef.current) return;
      setPermission(result.permission);
      setAddPermission(result.addPermission);
      setLoading(false);
      return;
    }
    // Otherwise make a new request
    let addFlag = false;
    inflightRequests[orgId] = checkHasMattressBuilderPermission((flag) => {
      addFlag = flag;
      LogConsole('mattress builder add permission', flag);
    }).then((perm) => {
      LogConsole('mattress builder tab show permission', perm);
      const result = { permission: perm, addPermission: addFlag };
      permissionCache[orgId] = result;
      delete inflightRequests[orgId];
      return result;
    });
    const result = await inflightRequests[orgId];
    if (!isMountedRef.current) return;
    setPermission(result.permission);
    setAddPermission(result.addPermission);
    setLoading(false);
  };

  return { loading, permission, addPermission };
};
